import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrow180 = () => {
  return (
    <g>
      <path d="M14.75 1a.75.75 0 0 1 .102 1.493l-.102.007h-9a4.25 4.25 0 0 0-.206 8.495L5.75 11h7.748l-1.286-1.277-.07-.08a.712.712 0 0 1 .07-.933.727.727 0 0 1 .932-.076l.09.076 2.555 2.533a.72.72 0 0 1 .102.127l.032.057.038.09.03.12.009.091-.005.112-.009.052a.71.71 0 0 1-.063.18l-.032.058-.032.046-.07.08-2.555 2.534a.727.727 0 0 1-1.022 0 .712.712 0 0 1-.07-.933l.07-.08 1.285-1.277H5.75a5.75 5.75 0 0 1-.22-11.496L5.75 1h9z" />
    </g>
  );
};

export default withIcon(IconArrow180);
